import service from "../util/http";

// 零部件类别
export const getComponentCategoryList = () => {
  return service({
    url: "manage/car/feedback/question/getComponentCategoryList",
    method: "get",
  });
};

// 当前登录用户在整车角色范围内的国家列表
export const getCarScopeCountries = () => {
  return service({
    url: "manage/car/feedback/question/scopeCountries",
    method: "get",
  });
};

/**
 * 获取问题总的统计数据
 * @return {*}
 */
export const requestQuestionAllCountData = (data) => {
  return service({
    url: "manage/car/feedback/data/getQuestionAllCountData",
    method: "post",
    data
  });
};


/**
 * 获取问题统计数据
 * @return {*}
 */
export const requestQuestionStatisTableData = (data) => {
  return service({
    url: "manage/car/feedback/data/getQuestionStatisTableData",
    method: "post",
    data
  });
};

export const requestQuestionStatisTableAccountData = (data) => {
  return service({
    url: "manage/car/feedback/data/getQuestionStatisTableAccountData",
    method: "post",
    data
  });
};

// 质量反馈单删除
export const deleteEmptyFormApi = (questionId) => {
  return service({
    url: "manage/car/feedbackForm/deleteEmptyForm?feedbackFormId=" + questionId,
    method: "post",
  })
}

// 表单重置
export const feedbackFormReset = (feedbackFormId) => {
  return service({
    url: "manage/car/feedbackForm/reset?feedbackFormId="+ feedbackFormId,
    method: "post",
  });
}
// 问题重置
export const feedbackQuestionReset = (questionId) => {
  return service({
    url: "manage/car/feedbackForm/resetByQuestionId?questionId=" + questionId,
    method: "post",
  });
}
// 问题回退
export const feedbackQuestionBack = (questionId) => {
  return service({
    url: "manage/car/feedbackForm/resetToNode?questionId=" + questionId,
    method: "post",
  });
}


// 流程及问题关闭
export const feedbackFormFinish = (questionId) => {
  return service({
    url: "manage/car/feedbackForm/finish?questionId="+ questionId,
    method: "post",
  });
}
// 反馈单删除(质量反馈开发)
export const feedbackFormDelete = (questionId) => {
  return service({
    url: "manage/car/feedbackForm/delete?feedbackFormId="+ questionId,
    method: "post",
  });
}
// 修改审核时间
export const getAuditTime = data => {
  return service({
    url: "/manage/flowable/task/updateAuditTime",
    method: "post",
    data
  });
};
// 获取审批流程图
export const getFlowDiagram = questionId => {
  return service({
    url: "/manage/car/feedback/question/diagram?questionId=" + questionId,
    method: "post"
  });
};

// 请求提交审核
export const requestSubmitAudit = data => {
  return service({
    url: "/manage/car/feedback/question/audit",
    method: "post",
    data
  });
};


/**
 * 获取问题流程信息
 * @param data
 * @return {*}
 */
export const requestQuestionFlowInsInfo = data => {
  return service({
    url: "/manage/car/feedback/question/getFlowByQuestionId",
    method: "get",
    params:data
  });
};

// 请求任务详情
export const requestTaskDetail = data => {
  return service({
    url: "/manage/car/feedback/question/getTaskById",
    method: "get",
    params:data
  });
};

//根据关键字搜索临时方案
export const requestSearchTempSolution = data => {
  return service({
    url: "/manage/tempSolution/findSolution",
    method: "get",
    params:data
  });
};

// 车架号维护列表
export const carVinManageListApi = data => {
  return service({
    url: "/manage/car/presetData/list",
    method: "post",
    data
  });
};

// 车架号新增
export const carVinAdd = data => {
  return service({
    url: "/manage/car/presetData/add",
    method: "post",
    data
  });
};

// 车架号修改
export const carVinEdit = data => {
  return service({
    url: "/manage/car/presetData/update",
    method: "post",
    data
  });
};

// 车架号删除
export const deleteCarVin = data => {
  return service({
    url: "/manage/car/presetData/delete",
    method: "post",
    data
  });
};

// 质量反馈列表
export const problemListApi = data => {
  return service({
    url: "/manage/car/feedback/question/questionList",
    method: "post",
    data
  });
};
// 问题列表详情
export const problemQuestionDetailApi = data => {
  return service({
    url: "manage/car/feedback/question/detail",
    method: "get",
    params:data
  });
};
// 质量反馈问题明细列表
export const problemDetailListApi = data => {
  return service({
    url: "/manage/car/feedback/question/questionTaskList",
    method: "post",
    data
  });
};

// 审核
export const auditProblem = data => {
  return service({
    url: "/manage/car/feedback/question/audit",
    method: "post",
    data
  });
};

// 审核不保存数据
export const auditProblemNot = data => {
  return service({
    url: "/manage/car/feedback/question/auditNotSave",
    method: "post",
    data
  });
};

// 审核记录
export const auditHistoryList = data => {
  return service({
    url: "/manage/car/feedback/question/auditHistoryList",
    method: "post",
    data
  });
};

// 获取用户列表
export const staffList = data => {
  return service({
    url: "/manage/car/feedback/question/staffList",
    method: "post",
    data
  });
};

// 获取客户列表
export const customerList = data => {
  return service({
    url: "/manage/car/feedback/question/customerList",
    method: "post",
    data
  });
};

// 获取质量反馈列表
export const feedbackList = data => {
  return service({
    url: "/manage/car/feedback/question/list",
    method: "post",
    data
  });
};

// 根据车型获取vin列表信息
export const checkModelApi = data => {
  return service({
    url: "/manage/car/feedback/question/checkModel",
    method: "post",
    data
  });
};
// 获取疑似/祸首件名称
export const getCheckPartApi = (data) => {
  return service({
    url: "/manage/car/feedback/question/checkPart",
    method: "post",
    data,
  });
};
// 获取车架号数据
export const getCarDataByVinApi = data => {
  return service({
    url: "/manage/car/feedback/question/getModel",
    method: "post",
    data
  });
};
// (售前车 | 售后车)问题列表
export const getQuestionListApi = data => {
  return service({
    url: "/manage/car/feedback/question/editQuestion",
    method: "post",
    data
  });
};
// (售前车 | 售后车)问题列表
export const preAfterSalesQuestionListApi = data => {
  return service({
    url: "/manage/car/feedback/question/questionListByForm",
    method: "post",
    data
  });
};

// （售前车 | 售后车）质量反馈提交
export const preAfterSubmitApi = data => {
  return service({
    url: "/manage/car/feedback/question/submit",
    method: "post",
    data
  });
};

// 售前车问题新增
export const preProblemAddApi = data => {
  return service({
    url: "/manage/car/feedback/question/add",
    method: "post",
    data
  });
};

// 售前车问题编辑
export const preProblemEditApi = data => {
  return service({
    url: "/manage/car/feedback/question/edit",
    method: "post",
    data
  });
};

// 售前车问题删除
export const preProblemDeleteApi = data => {
  return service({
    url: "/manage/car/feedback/question/removeQuestion",
    method: "post",
    data
  });
};

// 售后车反馈单新增
export const afterFeedbackAddApi = data => {
  return service({
    url: "/manage/car/feedback/question/addAfter",
    method: "post",
    data
  });
};

// 售后车反馈单编辑
export const afterFeedbackEditApi = data => {
  return service({
    url: "/manage/car/feedback/question/editAfter",
    method: "post",
    data
  });
};

// 售后车问题编辑
export const afterProblemEditApi = data => {
  return service({
    url: "/manage/car/feedback/question/editQuestion",
    method: "post",
    data
  });
};

// 查询巡检记录
export const getInspectRecordListApi = data => {
  return service({
    url: "/manage/car/feedback/question/inspectRecordList",
    method: "post",
    data
  });
};

// 上传巡检记录
export const addInspectRecordApi = data => {
  return service({
    url: "/manage/car/feedback/question/addInspectRecord",
    method: "post",
    data
  });
};

// 已有应急措施列表
export const getEmergencyMeasureListApi = data => {
  return service({
    url: "/manage/car/feedback/question/emergencyMeasureList",
    method: "post",
    data
  });
};

// 反馈问题统计
export const getQuestionStatisApi = data => {
  return service({
    url: "/manage/car/feedback/data/questionList",
    method: "post",
    data
  });
};

// 故障类型分布
export const getFaultTypeStatisApi = data => {
  return service({
    url: "/manage/car/feedback/data/faultTypeList",
    method: "post",
    data
  });
};

// 问题处理情况
export const getQuestionHandleStatisApi = data => {
  return service({
    url: "/manage/car/feedback/data/handleList",
    method: "post",
    data
  });
};

// 待处理问题统计
export const getQuestionPendingStatisApi = data => {
  return service({
    url: "/manage/car/feedback/data/pendingList",
    method: "post",
    data
  });
};

// 问题处理时效排行
export const getAuditTimeStatisApi = data => {
  return service({
    url: "/manage/car/feedback/data/auditTimeList",
    method: "post",
    data
  });
};

// 获取问题来源国家统计
export const getSourceCountryStatisApi = data => {
  return service({
    url: "/manage/car/feedback/data/questionListByCountry",
    method: "post",
    data
  });
};

// 获取售前车订单故障率
export const getFaultTaxStatisApi = data => {
  return service({
    url: "/manage/car/feedback/data/faultTaxList",
    method: "post",
    data
  });
};

// 获取售前车订单故障率
export const getTrendStatisApi = data => {
  return service({
    url: "/manage/car/feedback/data/questionListByTime",
    method: "post",
    data
  });
};

// 获取数据报表列表
export const dataReportListApi = data => {
  return service({
    url: "manage/car/feedback/data/dataList",
    method: "post",
    data
  });
};

// 导出数据报表
export const dataReportExport = data => {
  return service({
    url: "manage/car/feedback/data/exportDataList",
    method: "post",
    responseType: "blob",
    data
  });
};

// 质量问题导出
export const problemExportApi = data => {
  return service({
    url: "manage/car/feedback/question/exportDataList",
    method: "post",
    responseType: "blob",
    data
  });
};
// 历史记录查询   问题id
//审核类型 0 :有解决方案 1:类型一  2:类型二(附件)  只有应急措施   3:类型三
export const queryHistoryList = data => {
  return service({
    url: "/manage/claim/auditHistoryOperatioList",
    method: "post",
    data
  });
};
// 典型问题列表
export const typicalProblemListApi = data => {
  return service({
    url: "/manage/car/feedback/question/questionPage",
    method: "post",
    data
  });
};

// 时效列表
export const timeEfficiencyPageApi = (data) => {
  return service({
    url: '/manage/car/feedback/question/timeEfficiencyPage',
    method: 'post',
    data
  })
}

// 时效列表导出
export const timeEfficiencyPageApiExport = data => {
  return service({
    url: "/manage/car/feedback/question/exportTimeEfficiencyList",
    method: "post",
    responseType: "blob",
    data
  });
};

//新增附言
export const addPostscript = data => {
  return service({
    url: "/manage/car/feedback/question/addPostscript",
    method: "post",
    data
  });
};
//根据订单号查询订单数量
export const getVehicleAmountByOrderNumber = data => {
  return service({
    url: "/manage/car/feedback/question/getVehicleAmountByOrderNumber?orderNumber=" + data,
    method: "get",
  });
};
